import './App.css';
import { ThemeProvider } from '@mui/material';
import Routing from './Routing';
import Theme from './Theme/Theme';
import HelmetMetaData from './Components/HelmetMetaData';
import { GlobalThemeProvider } from './Components/Context/TimerContext';
import { NotificationProvider, useNotification } from './Components/Context/NotificationContext';
import React from 'react';
import { setNotificationFunction } from './Utils';

function AppContent() {
  const showNotification = useNotification();
  
  // Set the notification function for the httpclient
  React.useEffect(() => {
    setNotificationFunction(showNotification);
  }, [showNotification]);

  return (
    <>
      <HelmetMetaData />
      <ThemeProvider theme={Theme}>
        <Routing />
      </ThemeProvider>
    </>
  );
}

function App() {
  return (
    <GlobalThemeProvider>
      <NotificationProvider>
        <AppContent />
      </NotificationProvider>
    </GlobalThemeProvider>
  );
}

export default App;